'use strict';

const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};

class Pricing {
    constructor() {
        this.class = {
            module: '.module-pricing',
            imageWrapper: '.image-wrapper',
            container: '.pricing-body',
        };

        this.pricetableScrollHandler = this.pricetableScrollHandler.bind(this);
        this.updateParallaxEffect = this.updateParallaxEffect.bind(this);

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.init();
            }, false);
        } else {
            this.init();
        }
    }

    init() {
        this.updateParallaxEffect();
        window.addEventListener('resize', this.checkViewportWidth.bind(this));
        this.checkViewportWidth();
    }

    checkViewportWidth() {
        if (window.innerWidth > breakpoints.lg) {
            this.pricetableScrollHandler();
            this.updateParallaxEffect();
        } else {
            window.removeEventListener('scroll', this.updateParallaxEffect);
        }
    }

    pricetableScrollHandler() {
        window.addEventListener('scroll', this.updateParallaxEffect);
    }

    updateParallaxEffect() {
        if (window.innerWidth >= breakpoints.md) {
            const module = document.querySelector(this.class.module);

            if (module) {
                const imageWrapper = module.querySelector(this.class.imageWrapper);
                const container = module.querySelector(this.class.container);
                const offset = 0.3 * window.innerHeight;

                if (imageWrapper && container) {
                    const containerRect = container.getBoundingClientRect();
                    const containerHeight = containerRect.height;
                    const containerTop = containerRect.top;
                    const windowHeight = window.innerHeight;

                    const scrollPosition = window.scrollY || window.pageYOffset;
                    const visibleTop = Math.max(0, scrollPosition + windowHeight - (containerTop + offset));
                    const visiblePercentage = Math.max(0, Math.min(1, visibleTop / (containerHeight + windowHeight)));

                    const startTranslateY = 30;
                    const endTranslateY = -10;
                    const translateY = startTranslateY + (endTranslateY - startTranslateY) * visiblePercentage;

                    imageWrapper.style.transform = `translateY(${translateY}%)`;
                }
            }
        }
    }
}

new Pricing();

class Hero {
    constructor() {
        this.class = {
            module: '.module-hero',
            parallaxImage: '.parallax-image img',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    init() {
        this.parallaxImage();
    }

    parallaxImage() {
        const module = document.querySelector(this.class.module);

        if (!module) {
            return;
        }

        const image = module.querySelectorAll(this.class.parallaxImage);
        if (image) {
            new simpleParallax(image, {
                overflow: false,
                orientation: 'down',
                scale: 1.3, // Increase scale for a more noticeable effect
                delay: 0,
            });
        }
    }
}

new Hero();

class Mediarichtext {
    constructor() {
        this.class = {
            module: '.module-media-richtext',
            parallaxImage: '.parallax-image',
            moduleYellowBg: '.bg_yellow',
            optionalImage: '.media-image-opt',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    init() {
        if (document.querySelector(this.class.module)) {
            new Rellax('.rellax', {
                wrapper: '.media-richtext-container',
                speed: -2,
            });
            this.checkOptionalImage();
            window.addEventListener('resize', this.checkOptionalImage.bind(this));
        }
    }

    checkOptionalImage() {
        const modules = document.querySelectorAll(this.class.module);
        modules.forEach((module) => {
            if (module.querySelector(this.class.optionalImage)) {
                const parent = module.querySelector(this.class.moduleYellowBg);
                const child = parent.querySelector(this.class.optionalImage);
                if (window.innerWidth >= breakpoints.md) {
                    const parentHeight = parent.clientHeight;
                    const childHeight = child.clientHeight;
                    if (childHeight > (parentHeight - 50)) {
                        child.style.top = 'unset';
                        child.style.bottom = '-51px';
                        child.style.transform = 'none';
                    }
                } else {
                    child.removeAttribute('style');
                    child.style.bottom = '-32px';
                }
            }
        });
    }
}

new Mediarichtext();

class Footer {
    constructor() {
        this.class = {
            module: '.footer',
            footerLinkTitleWrapper: '.footer-link__title-wrapper',
            footerLinkGroup: '.footer-link__group',
        };

        this.toggleHandler = this.toggleHandler.bind(this);

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.init();
            }, false);
        } else {
            this.init();
        }
    }

    init() {
        this.checkViewportWidth();
        window.addEventListener('resize', this.checkViewportWidth.bind(this));
    }

    checkViewportWidth() {
        if (window.innerWidth <= breakpoints.md) {
            this.attachEventListeners();
        } else {
            this.removeEventListeners();
        }
    }

    attachEventListeners() {
        const module = document.querySelector(this.class.module);
        if (!module) return;

        const linkTitleWrappers = module.querySelectorAll(this.class.footerLinkTitleWrapper);

        linkTitleWrappers.forEach(wrapper => {
            wrapper.addEventListener('click', this.toggleHandler);
        });
    }

    removeEventListeners() {
        const module = document.querySelector(this.class.module);
        if (!module) return;

        const linkTitleWrappers = module.querySelectorAll(this.class.footerLinkTitleWrapper);

        linkTitleWrappers.forEach(wrapper => {
            wrapper.removeEventListener('click', this.toggleHandler);
        });
    }

    toggleHandler(event) {
        const module = document.querySelector(this.class.module);
        if (!module) return;

        const clickedWrapper = event.currentTarget;
        const group = clickedWrapper.nextElementSibling;

        if (group && module.contains(group) && group.classList.contains(this.class.footerLinkGroup.substring(1))) {
            clickedWrapper.classList.toggle('open');
            group.classList.toggle('open');
        }
    }
}

new Footer();

document.addEventListener('DOMContentLoaded', () => {
    const fullScreenSlider = document.querySelectorAll('.slider-fullscreen .swiper');
    const contentSlider = document.querySelectorAll('.slider-content .swiper');
    const relatedSlider = document.querySelectorAll('.slider-related .swiper');

    if (fullScreenSlider) {
        fullScreenSlider.forEach(slider => {
            const paginationElement = slider.querySelector('.swiper-pagination');
            const nextButton = slider.querySelector('.swiper-button-next');
            const prevButton = slider.querySelector('.swiper-button-prev');

            new Swiper(slider, {
                slidesPerView: 1.1,
                spaceBetween: 16,
                loop: false,
                pagination: {
                    el: paginationElement,
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2.6,
                        spaceBetween: 32,
                    },
                    768: {
                        slidesPerView: 3.5,
                        spaceBetween: 32,
                    },
                },
            });
        });
    }

    if (contentSlider) {
        contentSlider.forEach(slider => {
            const paginationElement = slider.querySelector('.swiper-pagination');
            const nextButton = slider.querySelector('.swiper-button-next');
            const prevButton = slider.querySelector('.swiper-button-prev');

            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: false,
                pagination: {
                    el: paginationElement,
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 32,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 32,
                    },
                },
            });
        });
    }

    if (relatedSlider) {
        relatedSlider.forEach(slider => {
            const paginationElement = slider.querySelector('.swiper-pagination');
            const nextButton = slider.querySelector('.swiper-button-next');
            const prevButton = slider.querySelector('.swiper-button-prev');

            new Swiper(slider, {
                slidesPerView: 1.1,
                spaceBetween: 16,
                loop: false,
                pagination: {
                    el: paginationElement,
                    clickable: true,
                    dynamicBullets: true,
                },
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 32,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 32,
                    },
                },
            });
        });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const bigQuote = document.querySelectorAll('.module_bigquote');

    bigQuote.forEach(bquoteSlider => {

        const slider = bquoteSlider.querySelector('.swiper');
        const paginationElement = bquoteSlider.querySelector('.swiper-pagination');
        const nextButton = bquoteSlider.querySelector('.swiper-button-next');
        const prevButton = bquoteSlider.querySelector('.swiper-button-prev');

        // pagination
        const fraction = bquoteSlider.querySelector('.swiper-fraction');
        const slides = slider.querySelectorAll('.swiper-slide');
        const slideCount = slides.length;
        fraction.textContent = `1 / ${slideCount}`;
        const type = paginationElement.classList.contains('progressbar') ? 'progressbar' : 'bullets';

        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: false,
            pagination: {
                el: paginationElement,
                clickable: true,
                dynamicBullets: true,
                type: type,
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },

            breakpoints: {
                576: {
                    slidesPerView: 1.7,
                    // spaceBetween: 32,
                    centeredSlides: true,
                },
            },

            on: {
                slideChange: () => {
                    fraction.textContent = `${swiper.realIndex + 1} / ${slideCount}`;
                },
            },
        });

        swiper.on('slideChange', () => {
            const bodyText = bquoteSlider.querySelector('.quote-body');
            const newBodyText = bquoteSlider.querySelector('.hiddenSlideContent-' + swiper.activeIndex).innerHTML;
            bodyText.innerHTML = newBodyText;
        });
    });
});

// this is similiar to bigquote slider
document.addEventListener('DOMContentLoaded', () => {
   const businesscard = document.querySelectorAll('.module_businesscard');

    businesscard.forEach(businesscardSlider => {
        let num = 1;
        let swiper; // Variable für Swiper-Instanz

        const slider = businesscardSlider.querySelector('.swiper');
        const paginationMobile = businesscardSlider.querySelector('.swiper-pagination.swiper-pagination-mobile');
        const paginationDesktop = businesscardSlider.querySelector('.swiper-pagination.swiper-pagination-desktop');
        const nextButton = businesscardSlider.querySelector('.swiper-button-desktop.swiper-button-next');
        const nextButtonMobile = businesscardSlider.querySelector('.swiper-button-mobile.swiper-button-next');
        const prevButton = businesscardSlider.querySelector('.swiper-button-desktop.swiper-button-prev');
        const prevButtonMobile = businesscardSlider.querySelector('.swiper-button-mobile.swiper-button-prev');

        // Funktion zur Swiper-Initialisierung basierend auf der Bildschirmbreite
        function initSwiper() {
            // Falls Swiper bereits existiert, zerstören und neu erstellen
            if (swiper) swiper.destroy(true, true);

            const isDesktop = window.innerWidth >= 768;
            const paginationElement = isDesktop ? paginationDesktop : paginationMobile;
            const nextButtonEL = isDesktop ? nextButton : nextButtonMobile;
            const prevButtonEL = isDesktop ? prevButton : prevButtonMobile;

            const slides = slider.querySelectorAll('.swiper-slide');
            const useDynamicBullets = slides.length > 5;
console.log(nextButtonEL);
            swiper = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: false,
                pagination: {
                    el: paginationElement, // Dynamische Auswahl des Pagination-Elements
                    clickable: true,
                    dynamicBullets: useDynamicBullets,
                },
                navigation: {
                    nextEl: nextButtonEL,
                    prevEl: prevButtonEL,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1.7,
                        spaceBetween: 40,
                        centeredSlides: true,
                    }
                }
            });

            // SlideChange Event, um Inhalte zu ändern
            swiper.on('slideChange', () => {
                const bodyText = businesscardSlider.querySelector('.businesscard-body');
                const newBodyText = businesscardSlider.querySelector('.hiddenSlideContent-' + swiper.activeIndex).innerHTML;
                bodyText.innerHTML = newBodyText;
                num = swiper.activeIndex + 1;
            });
        }

        // Initial Swiper starten
        initSwiper();

        // Neu initialisieren, wenn sich die Fenstergröße ändert
        window.addEventListener('resize', initSwiper);
    });
});

class FullWidthMedia {
    constructor() {
        this.class = {
            module: '.module-fullwidthmedia',
            parallaxImage: '.parallax-image img',
            video: 'video',
            playPauseButton: '.btn.play-pause',
            playIcon: 'fa-play',
            pauseIcon: 'fa-pause',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    init() {
        this.initParallaxImages();
        this.initVideoControls();
    }

    initParallaxImages() {
        const modules = document.querySelectorAll(this.class.module);

        if (modules.length === 0) {
            return;
        }

        modules.forEach(module => {
            const images = module.querySelectorAll(this.class.parallaxImage);

            if (images.length > 0) {
                new simpleParallax(images, {
                    overflow: true,
                    orientation: 'down',
                    scale: 1.7,
                    delay: 0,
                });
            }
        });
    }

    initVideoControls() {
        const modules = document.querySelectorAll(this.class.module);

        if (modules.length === 0) {
            return;
        }

        modules.forEach(module => {
            const video = module.querySelector(this.class.video);
            const playPauseButton = module.querySelector(this.class.playPauseButton);

            if (video && playPauseButton) {
                this.updateButtonIcon(video, playPauseButton);

                playPauseButton.addEventListener('click', () => {
                    if (video.paused) {
                        video.play();
                    } else {
                        video.pause();
                    }
                    this.updateButtonIcon(video, playPauseButton);
                });

                video.addEventListener('play', () => this.updateButtonIcon(video, playPauseButton));
                video.addEventListener('pause', () => this.updateButtonIcon(video, playPauseButton));
            }
        });
    }

    updateButtonIcon(video, button) {
        const playIcon = button.querySelector(`.${this.class.playIcon}`);
        const pauseIcon = button.querySelector(`.${this.class.pauseIcon}`);

        if (playIcon && pauseIcon) {
            if (video.paused) {
                playIcon.style.display = 'block';
                pauseIcon.style.display = 'none';
            } else {
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
            }
        }
    }
}

new FullWidthMedia();

class Highlights {
    constructor() {
        this.class = {
            module: '.module-highlights',
            accordionCollapse: '.accordion-collapse',
        };

        this.init = this.init.bind(this);
        this.onResize = this.onResize.bind(this);

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init, false);
        } else {
            this.init();
        }
    }

    init() {
        this.updateAccordionBehavior();
        window.addEventListener('resize', this.onResize);
    }

    onResize() {
        this.updateAccordionBehavior();
    }

    updateAccordionBehavior() {
        const isMobile = window.innerWidth < breakpoints.xl;

        document.querySelectorAll(this.class.module).forEach(module => {
            const collapses = module.querySelectorAll(this.class.accordionCollapse);

            if (collapses.length === 0) {
                return;
            }

            collapses.forEach(collapse => {
                if (isMobile) {
                    collapse.removeAttribute('data-bs-parent');
                } else {
                    const accordionId = collapse.closest('.accordion').id;
                    collapse.setAttribute('data-bs-parent', `#${accordionId}`);
                }
            });
        });
    }
}

new Highlights();

document.addEventListener('DOMContentLoaded', () => {
    const stageContentEl = document.querySelectorAll('.module-stage-content');

    if (!stageContentEl) {
        return;
    }

    stageContentEl.forEach((stageContent) => {
        const parallaxImage = stageContent.querySelector('.parallax-image img');

        if (parallaxImage) {
            new simpleParallax(parallaxImage, {
                overflow: false,
                orientation: 'up',
                scale: 1.1, // Increase scale for a more noticeable effect
                delay: 3,
            });
        }
    });
});

class Counter {
    constructor() {
        this.class = {
            module: '.module-benefitsboxnumbers',
            moduleCounter: '.benefits-counter',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    init() {
        if (document.querySelector(this.class.module)) {
            const options = {
                root: null, // the viewport
                threshold: 1.0, // 100% visible
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const element = entry.target;
                        this.animateNumber(element);
                        observer.unobserve(element);
                    }
                });
            }, options);

            const modcounter = document.querySelectorAll(this.class.moduleCounter);
            modcounter.forEach((counter) => {
                observer.observe(counter);
            });
        }
    }

    animateNumber(element) {
        const numfield = element;
        const counter = element.querySelector('.number');
        const start = parseFloat(numfield.dataset.startnumber);
        const end = parseFloat(numfield.dataset.endnumber);
        const increase = parseFloat(numfield.dataset.increasenumber);
        const numType = numfield.dataset.numbertype;
        const numFloatDigits = numfield.dataset.increasenumber.length - 1;
        const duration = 2000;

        let current = start;
        const increment = increase;
        const range = parseInt(Math.ceil((end - start) / increase), 0);
        const stepTime = Math.abs(Math.floor(duration / range));

        const timer = setInterval(() => {
            current += increment;
            const cu = current.toFixed(numFloatDigits);
            if (parseFloat(cu) >= end) {
                if (parseFloat(cu) !== end) {
                    current = end;
                    counter.textContent = this.formatNumber(current, numType, numFloatDigits);
                }
                clearInterval(timer);
            }
            if (parseFloat(cu) <= end) {
                counter.textContent = this.formatNumber(current, numType, numFloatDigits);
            }
        }, stepTime);
    }

    formatNumber(num, numType, digits) {
        let retNum;
        switch (numType) {
            case 'float':
                retNum = num.toFixed(digits)
                    .replace(/\./g, ',')
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                break;

            case 'int':
                retNum = num.toFixed(0)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                break;

            default:
                retNum = num.toFixed(0);
        }
        return retNum;
    }
}

new Counter();

document.addEventListener('DOMContentLoaded', function () {
    const buttonsContainer = document.querySelector('.container_contact');

    if (!buttonsContainer){
        return;
    }

    const forms = document.querySelectorAll('.container_contact .container_form');
    const decisiongroups = document.querySelectorAll('.container_contact .decision-group');


    const contactForms = buttonsContainer.querySelectorAll('.container_form');

    contactForms.forEach(form=> {
        const errorClass = form.querySelector('.has-error');
        if (errorClass) {
            form.classList.remove('d-none');
            form.classList.add('d-block');
            form.closest('.decision-group').classList.add('d-block');
        }
    });

    function adjustId(id) {
        if (!document.getElementById(id)) {
            return id.replace(/form-(\d+)-\d+$/, 'decision-group-$1');
        }
        return id;
    }

    function showParentGroups(element) {
        while (element && !element.classList.contains('container_contact')) {
            if (element.classList.contains('decision-group')) {
                // element.style.display = 'block';
                element.classList.remove('d-none');
                element.classList.add('d-block');
            }
            element = element.parentElement;
        }
    }

    // Überprüfen, ob es mindestens ein Element gibt, um Fehler zu vermeiden
    if (decisiongroups.length > 0) {
        // erste Entscheidungsgruppe aktivieren
        // decisiongroups[0].style.display = 'block';
        decisiongroups[0].classList.remove('d-none');
        decisiongroups[0].classList.add('d-block');
    }

    // Event-Delegation: Anstatt auf jeden Button separat einen Listener zu setzen,
    // setzen wir einen Listener auf den Container für die Buttons.
    if(buttonsContainer){
        buttonsContainer.addEventListener('click', function (event) {
            const button = event.target.closest('.js-form-toggle');
            if (!button) return; // Klick war nicht auf einen relevanten Button

            const formId = button.getAttribute('data-form-id');

            // Alle Formulare ausblenden
            forms.forEach(form => {
                form.classList.remove('d-block');
                form.classList.add('d-none');
            });

            // Alle Entscheidungsgruppen ausblenden außer der ersten
            decisiongroups.forEach((group, index) => {
                if (index !== 0) {
                    group.classList.remove('d-block');
                    group.classList.add('d-none');
                }
            });

            // Das ausgewählte Formular oder die Entscheidungsgruppe einblenden
            const activeFormOrDecision = document.getElementById(adjustId(formId));
            if (activeFormOrDecision) {
                //activeFormOrDecision.style.display = 'block';
                activeFormOrDecision.classList.remove('d-none');
                activeFormOrDecision.classList.add('d-block');
                showParentGroups(activeFormOrDecision);
            }

            // Button-Stile aktualisieren
            buttonsContainer.querySelectorAll('.js-form-toggle').forEach(btn => {
                btn.classList.remove('btn-secondary', 'active');
                btn.classList.remove('btn-secondary');
            });
            button.classList.remove('btn-outline-secondary');
            button.classList.add('btn-secondary', 'active');
        });
    }
});

class FaqSearch {
    constructor(searchInputId, categoryFilterSelector, noResultsMessageSelector, filteredTermsContainerSelector) {
        this.searchInput = document.getElementById(searchInputId);
        this.categoryFilters = Array.from(document.querySelectorAll(categoryFilterSelector));
        this.categoryContainers = Array.from(document.querySelectorAll('.category-container'));
        this.noResultsMessage = document.querySelector(noResultsMessageSelector);
        this.filteredTermsContainer = document.querySelector(filteredTermsContainerSelector);

        this.selectedCategories = new Set(); // Track selected categories as a Set

        this.initSearch();
        this.initCategoryFilters();
    }

    // Initialize search functionality
    initSearch() {
        if (this.searchInput) {
            this.searchInput.addEventListener('input', this.applyFilters.bind(this));
        }
    }

    // Initialize category filter functionality
    initCategoryFilters() {
        this.categoryFilters.forEach(filter => {
            filter.addEventListener('click', (event) => {
                event.preventDefault();

                const categoryId = filter.getAttribute('data-category');

                // Toggle category selection
                if (this.selectedCategories.has(categoryId)) {
                    this.selectedCategories.delete(categoryId); // Deselect if already selected
                    filter.classList.remove('active');
                } else {
                    this.selectedCategories.add(categoryId); // Select new category
                    filter.classList.add('active');
                }

                this.updateFilteredTerms();
                this.applyFilters();
            });
        });
    }

    // Update the filtered search terms display
    updateFilteredTerms() {
        // Clear existing filtered terms
        this.filteredTermsContainer.innerHTML = '';

        // If no categories are selected, clear the container
        if (this.selectedCategories.size === 0) {
            return;
        }

        // Add the header text for filtered terms
        const header = document.createElement('div');
        header.classList.add('filtered-header');
        header.textContent = 'Gefilterte Suchbegriffe:';
        this.filteredTermsContainer.appendChild(header);

        // Add a pill for each selected category
        this.selectedCategories.forEach(categoryId => {
            const categoryFilter = this.categoryFilters.find(filter => filter.getAttribute('data-category') === categoryId);
            const categoryName = categoryFilter ? categoryFilter.textContent : '';

            const pill = document.createElement('span');
            pill.classList.add('filter-term');
            pill.textContent = categoryName;

            // Add a remove button to the pill
            const removeButton = document.createElement('span');
            removeButton.classList.add('remove-filter');
            removeButton.textContent = ' ×';
            removeButton.addEventListener('click', () => {
                this.selectedCategories.delete(categoryId); // Remove category from selection
                categoryFilter.classList.remove('active'); // Unmark the filter button
                this.updateFilteredTerms(); // Update the pills
                this.applyFilters(); // Reapply the filters
            });

            pill.appendChild(removeButton);
            this.filteredTermsContainer.appendChild(pill);
        });
    }

    // Utility function to get category header
    getCategoryHeader(visibleFaqInCategory, categoryTitle) {
        return visibleFaqInCategory > 0
            ? `${visibleFaqInCategory} Treffer zum Thema "${categoryTitle}"`
            : `FAQs zum Thema: <strong>${categoryTitle}</strong>`;
    }

    // Apply filters based on search and selected categories
    applyFilters() {
        const searchQuery = this.searchInput.value.trim().toLowerCase();
        const searchInputGroup = this.searchInput.closest('.faq-search-input-group');
        const activeCategories = Array.from(this.selectedCategories);
        const searchRemoveButton = searchInputGroup.querySelector('.faq-remove-search-button');

        let totalVisibleFaqCount = 0;

        // reset search on click remove search input
        if (searchQuery.length > 0 ) {
            searchRemoveButton.classList.add('show-me');

            searchRemoveButton.addEventListener('click', () => {
                this.searchInput.value = '';
                this.applyFilters();
            });

        } else {
            searchRemoveButton.classList.remove('show-me');
        }

        // Handle categorized FAQs
        const categoryContainers = document.querySelectorAll('.category-container');
        categoryContainers.forEach(container => {
            const categoryTitle = container.getAttribute('data-category');
            const categoryHeader = container.querySelector('h5');
            const faqItems = Array.from(container.querySelectorAll('.accordion-item'));
            let visibleFaqInCategory = 0;

            faqItems.forEach(item => {
                const questionElement = item.querySelector('.accordion-button');
                const answerElement = item.querySelector('.accordion-body');

                const question = questionElement ? questionElement.textContent.toLowerCase() : '';
                const answer = answerElement ? answerElement.textContent.toLowerCase() : '';

                const dataCategory = item.getAttribute('data-category');
                const categories = dataCategory ? dataCategory.split(',') : [];

                const matchesSearch = searchQuery === '' || question.includes(searchQuery) || answer.includes(searchQuery);
                const matchesCategory = activeCategories.length === 0 || activeCategories.includes(categoryTitle);

                if (matchesSearch && matchesCategory) {
                    item.style.display = 'block';
                    visibleFaqInCategory++;
                    totalVisibleFaqCount++;
                } else {
                    item.style.display = 'none';
                }
            });

            // Update the category header dynamically
            const headerText = visibleFaqInCategory > 0
                ? `${visibleFaqInCategory} Treffer zum Thema "${categoryTitle}"`
                : `FAQs zum Thema: <strong>${categoryTitle}</strong>`;

            // If no search query or categories, always reset to original header
            categoryHeader.innerHTML = searchQuery === '' && activeCategories.length === 0
                ? `FAQs zum Thema: <strong>${categoryTitle}</strong>`
                : headerText;

            container.style.display = visibleFaqInCategory > 0 ? 'block' : 'none';
        });

        // Handle non-categorized FAQs with the same logic
        const nonCategorizedFaqItems = document.querySelectorAll('.non-categorized-item');
        nonCategorizedFaqItems.forEach(item => {
            const questionElement = item.querySelector('.accordion-button');
            const answerElement = item.querySelector('.accordion-body');

            const question = questionElement ? questionElement.textContent.toLowerCase() : '';
            const answer = answerElement ? answerElement.textContent.toLowerCase() : '';

            const dataCategory = item.getAttribute('data-category');
            const categories = dataCategory ? dataCategory.split(',') : [];

            const matchesSearch = searchQuery === '' || question.includes(searchQuery) || answer.includes(searchQuery);
            const matchesCategory = activeCategories.length === 0 || activeCategories.some(cat => categories.includes(cat));

            if (matchesSearch && matchesCategory) {
                item.style.display = 'block';
                totalVisibleFaqCount++;
            } else {
                item.style.display = 'none';
            }
        });

        // Show or hide the "No Results" message
        if (this.noResultsMessage) {
            this.noResultsMessage.style.display = totalVisibleFaqCount === 0 ? 'block' : 'none';
        }
    }

}

// Initialize the FAQ search functionality
new FaqSearch(
    'faqSearchInput',         // Search input ID
    '.faq-filter',            // Category filter selector
    '#no-results',            // "No Results" message selector
    '.filtered-search-terms'  // Filtered search terms container
);

document.addEventListener('DOMContentLoaded', () => {
    const formEle = document.querySelector('.module form');

    if (!formEle) {
        return;
    }

    const btn = formEle.querySelector('button[type="submit"]');
    const inputs = formEle.querySelectorAll(".form-control, .form-check, input");

    btn.addEventListener("click", () => {
        inputs.forEach(function (element) {
            // if input field passes validation remove the error class, else add it
            if (element.checkValidity())
                element.classList.remove('error-input');
            else
                element.classList.add('error-input');
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const appBox = document.querySelector('.app');
    if(appBox){
        let downloadButtons;
        let userAgent;
        let downloadLink = '';
        const qrcodesApp = document.querySelector('.qrcode_app');

        if (appBox) {
            // Get the reference to the <button> tag
            downloadButtons = document.querySelectorAll('.download_app');
            // Detect user agent to determine the device type
            userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (userAgent.includes('Android')) {
                // Android device
                downloadLink = 'https://play.google.com/store/apps/details?id=de.ewe.go.app';
            } else if (userAgent.includes('iPhone') || userAgent.includes('iPad') || userAgent.includes('iPod')) {
                // iOS device
                downloadLink = 'https://apps.apple.com/de/app/ewe-go/id1632031984';
            }
            downloadButtons.forEach((downloadButton) => {
                if (downloadLink !== '') {
                    // Attach click event listener
                    downloadButton.addEventListener('click', (event) => {
                        // Prevent the default action of the link/button (to prevent the page from refreshing in this case)
                        event.preventDefault();

                        // Navigate to the link
                        window.location.href = downloadLink;
                    });
                } else {
                    // hide download buttons
                    downloadButton.style.display = 'none';

                    // show QR Codes for the appstores
                    qrcodesApp.style.display = 'block';
                }
            });
        }
    }
});

class BackToTop {
    constructor() {
        this.class = {
            backToTop: '.js-back-to-top',
            bttTrigger: '.back-to-top__btn',
        };

        this.lastScrollTop = 0;
        this.updateScreenHeights();

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    updateScreenHeights() {
        this.desktopHeight = window.innerHeight;
        this.showAfterScroll = this.desktopHeight * 2; // Two times screen height
        this.minPageHeight = this.desktopHeight * 4; // Four times screen height
    }

    init() {
        this.backToTopEl = document.querySelector(this.class.backToTop);
        this.triggerEl = document.querySelector(this.class.bttTrigger);

        if (!this.backToTopEl || !this.triggerEl) return;

        const pageHeight = document.documentElement.scrollHeight;

        // activate only if the page is at least four times the screen height
        if (pageHeight < this.minPageHeight) return;

        this.calcHeight();
        window.addEventListener('resize', this.handleResize.bind(this));
        window.addEventListener('scroll', this.handleScroll.bind(this));
        this.initScrolling();
    }

    // updates values when the window is resized
    handleResize() {
        this.updateScreenHeights();
        this.calcHeight();
    }

    // controls when the button appears/disappears based on scrolling
    handleScroll() {
        const currentScroll = window.scrollY;

        if (currentScroll > this.showAfterScroll && currentScroll > this.lastScrollTop) {
            // show button when at least 2 times the screen height has been scrolled and scrolling down
            this.triggerEl.classList.add('back-to-top__btn--visible');
        } else if (currentScroll <= 0) {
            // hide button when reaching the top
            this.triggerEl.classList.remove('back-to-top__btn--visible');
        }

        this.lastScrollTop = currentScroll;
    }

    // adjusts the button’s position dynamically
    calcHeight() {
        const offset = this.backToTopEl.getBoundingClientRect().top + document.documentElement.scrollTop;
        this.backToTopEl.style.setProperty('--offset', `${offset}px`);
    }

    // enables smooth scrolling to the top when clicking the button
    initScrolling() {
        this.triggerEl.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }
}

new BackToTop();
